<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="name"
                  label="Price Model Name"
                  v-model="priceModel.name"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="regionList"
                  label="Choose Region ..."
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  @change="queryParams.regionId = priceModel.regionId"
                  v-model="priceModel.regionId"
                  :readonly="
                    user.role.roleName == 'GENERAL_MANAGER' ||
                    priceModel.id
                      ? true
                      : false
                  "
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="priceModel.description"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="priceModel.id">
                <v-text-field
                  label="Created Date"
                  v-model="createdDate"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="priceModel.id">
                <v-text-field
                  label="Created By"
                  v-model="priceModel.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="priceModel.id">
                <v-text-field
                  label="Updated Date"
                  v-model="updatedDate"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="priceModel.id">
                <v-text-field
                  label="Updated By"
                  v-model="priceModel.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="priceModel.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    type="submit"
                    :disabled="btnDisabled"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
              <v-flex v-if="priceModel.id">
                <div>
                  <v-layout row wrap>
                    <v-btn color="success" @click="showProducts()">
                      Add Price Model Detail
                      <v-icon right>add</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
                <v-flex xs12>
                  <v-card>
                    <v-layout row wrap class="pa-3">
                      <v-flex sm3>
                        <v-text-field
                          name="code"
                          label="Product Code"
                          type="text"
                          class="mr-1"
                          v-model="priceModelDetailQueryParams.productCode"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm3>
                        <v-text-field
                          name="name"
                          label="Product Name"
                          type="text"
                          class="mr-1"
                          v-model="priceModelDetailQueryParams.productName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm3>
                        <v-select
                          :items="activeBrandList"
                          v-model="priceModelDetailQueryParams.brandId"
                          label="Brand"
                          item-text="name"
                          item-value="id"
                          :hide-no-data="true"
                          menu-props="auto"
                        ></v-select>
                      </v-flex>
                      <v-flex sm3>
                        <v-select
                          :items="activeCategoryList"
                          v-model="priceModelDetailQueryParams.categoryId"
                          label="Category"
                          item-text="name"
                          item-value="id"
                          :hide-no-data="true"
                          menu-props="auto"
                        ></v-select>
                      </v-flex>
                      <v-flex sm3>
                        <v-select
                          :items="priceTypeList"
                          label="Price Type"
                          v-model="priceModelDetailQueryParams.priceType"
                          item-text="text"
                          item-value="value"
                          menu-props="auto"
                        ></v-select>
                      </v-flex>
                      <v-flex sm9>
                        <v-btn outline color="primary" @click="detailSearch">
                          Search
                          <v-icon right>search</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-btn
                        :loading="buttonLoading"
                        color="success"
                        @click="exportPriceModel()"
                        >EXPORT ALL
                      </v-btn>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs12 class="mt-1">
                  <v-card>
                    <v-data-table
                      :must-sort="true"
                      :headers="detailHeaders"
                      :items="priceModelDetailList"
                      class="elevation-1"
                      :loading="detailListLoading"
                      :total-items="detailTotalRows"
                      :rows-per-page-items="detailRowsPerPageItems"
                      :pagination.sync="detailPagination"
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.productCode }}</td>
                        <td>{{ props.item.productName }}</td>
                        <td>{{ props.item.factorUnitName }}</td>
                        <td>
                          <v-icon
                            v-if="props.item.basicPriceflag"
                            medium
                            color="green"
                            >spellcheck</v-icon
                          >
                          <v-icon v-else medium color="red"
                            >format_italic</v-icon
                          >
                        </td>
                        <td>{{ props.item.unitCost }}</td>
                        <td>{{ props.item.unitPrice }}</td>
                        <td>{{ props.item.sellingPrice }}</td>
                        <td>{{ props.item.sellingPricePercentage }}</td>
                        <td>
                          <v-btn
                            flat
                            icon
                            color="blue lighten-2"
                            @click="onEdit(props.item)"
                          >
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            @click="removePriceModelDetail(props.item)"
                          >
                            <v-icon>cancel</v-icon>
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              :headers="headers"
              :items="productList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td
                  @click="
                    setProduct(props.item.code),
                      (showProductListDialog = !showProductListDialog)
                  "
                >
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.brand.name }}</td>
                <td>{{ props.item.category.name }}</td>
                <td v-if="props.item.productGroup">
                  {{ props.item.productGroup.name }}
                </td>
                <td v-else></td>
                <td>{{ props.item.description }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Price Model detail dialog -->
    <v-dialog
      v-model="showDetailListDialog"
      scrollable
      max-width="1000px"
      persistent
    >
      <v-form v-model="productValid">
        <v-card>
          <v-card-title>
            <v-layout wrap>
              <v-flex sm12 v-if="detailResponseError">
                <span class="red--text">* {{ detailResponseError }}</span>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  name="priceModelName"
                  label="Price Model Name"
                  type="text"
                  class="mr-1"
                  v-model="priceModel.name"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-flex row wrap class="pa-3">
                  <v-layout row wrap class="light--text">
                    <v-flex xs1>Code</v-flex>
                    <v-flex xs3>Product</v-flex>
                    <v-flex xs2>Unit</v-flex>
                    <v-flex xs1>Basic Price</v-flex>
                    <v-flex xs1>Unit Cost</v-flex>
                    <v-flex xs1>Unit Price</v-flex>
                    <v-flex xs2>Selling Price</v-flex>
                    <v-flex xs1>Selling Price(%)</v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        placeholder="Product Code"
                        v-model="priceModelDetail.productCode"
                        :rules="rules.codeRules"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 pr-2>
                      <v-text-field
                        v-model="priceModelDetail.productName"
                        :loading="showAutocompleteLoading"
                        :readonly="true"
                        :rules="rules.nameRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 pr-2>
                      <v-autocomplete
                        v-model="priceModelDetail.factorUnitName"
                        :loading="showAutocompleteLoading"
                        :hide-no-data="true"
                        :items="priceModelDetail.productUnits"
                        color="blue-grey lighten-2"
                        item-value="factorUnitName"
                        item-text="factorUnitName"
                        @change="
                          changeProductUnit(priceModelDetail.factorUnitName)
                        "
                        menu-props="auto"
                        label="Select"
                        :rules="rules.unitRules"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-checkbox
                        v-model="priceModelDetail.basicPriceflag"
                        readonly
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        v-model="priceModelDetail.unitCost"
                        min="0"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        v-model="priceModelDetail.unitPrice"
                        min="0"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 pr-2>
                      <v-text-field
                        v-model="priceModelDetail.sellingPrice"
                        min="0"
                        :rules="rules.sellingPriceRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        v-model="priceModelDetail.sellingPricePercentage"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        :rules="rules.sellingPricePercentageRules"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-flex xs12>
                    <div class="text-xs-center">
                      <v-btn color="error" @click="cancel">
                        Cancel
                        <v-icon right>clear</v-icon>
                      </v-btn>
                      <v-btn
                        color="primary"
                        :loading="saveDetailLoading"
                        :disabled="!productValid"
                        @click.stop="saveDetail"
                      >
                        Save
                        <v-icon right>save</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-flex>
              </v-card>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- delete confirm box -->
    <v-dialog
      v-model="confirmBox"
      max-width="500px"
      @keydown.enter="deleteDetail()"
      @keydown.esc="open = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>
                Are you sure to delete this Price Model Detail({{
                  deletePriceModelDetail.productCode
                }})?
              </h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="confirmBox = false">Cancel</v-btn>
          <v-btn color="success" large outline @click="deleteDetail()"
            >Proceed</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { PriceModelRules } from "../../helpers/validation-rules";
import { PriceModel, PriceModelDetail } from "../../models/model";
import { productService } from "../../services/product-service";
import { priceModelService } from "../../services/price-model-service";
import { regionService } from "../../services/region-service";
import { brandService } from "../../services/brand-service";
import { categoryService } from "../../services/category-service";

export default {
  name: "PriceModelDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    productValid: true,
    breadcrumbs: [
      {
        text: "Price Model",
        disabled: false,
        to: "price-models",
      },
      {
        text: "Price Model Detail",
        disabled: true,
      },
    ],
    falseValue: 0,
    trueValue: 1,
    productList: [],
    regionList: [],
    productUnitList: [],
    priceModelDetailList: [],
    priceModel: new PriceModel(),
    oldPriceModel: new PriceModel(),
    priceModelDetail: new PriceModelDetail(),
    rules: new PriceModelRules(),
    updatedDate: "",
    createdDate: "",
    unitCost: 0,
    unitPrice: 0,
    statusFlag: true,
    saveLoading: false,
    showAutocompleteLoading: false,
    btnDisabled: false,

    responseError: "",
    detailResponseError: "",
    showProductListDialog: false,
    showDetailListDialog: false,
    saveDetailLoading: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    detailHeaders: [
      { text: "Code", value: "productCode" },
      { text: "Product", value: "productName" },
      { text: "Unit", value: "factorUnitName", sortable: false },
      { text: "Basic Price", value: "basicPriceflag", sortable: false },
      { text: "Unit Cost", value: "unitCost" },
      { text: "Unit Price", value: "unitPrice" },
      { text: "Selling Price", value: "sellingPrice" },
      { text: "Selling Price(%)", value: "sellingPricePercentage" },
      { text: "Action", value: "", sortable: false },
    ],

    rowsPerPageItems: [10, 50, 100],
    detailRowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    detailPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "p.code",
      totalItems: 0,
    },
    totalRows: 0,
    detailTotalRows: 0,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      regionId: "",
    },
    priceModelDetailQueryParams: {
      productName: "",
      productCode: "",
      priceModelId: "",
      brandId: "",
      categoryId: "",
      priceType: "",
    },
    search: null,
    code: "",
    showListLoading: false,
    detailListLoading: false,
    selectedIndex: 0,
    deletePriceModelDetail: new PriceModelDetail(),
    confirmBox: false,
    activeBrandList: [],
    activeCategoryList: [],
    findAll: { id: "", name: "---All---" },
    buttonLoading: false,
    priceTypeList: [
      { text: "---All---", value: "" },
      { text: "Basic Price", value: "BASICPRICE" },
    ],
  }),

  created() {
    this.getRegionList();
    this.getProductList();
    this.getActiveBrandList();
    this.getActiveCategoryList();
    const id = this.$route.params.id;
    if (id != "new") {
      this.getPriceModelDetail(id);
    }
    if (
      this.user.role.roleName == "SALE_MANAGER" ||
      this.user.role.roleName == "GENERAL_MANAGER"
    ) {
      if (this.user.shop.regionId)
        this.priceModel.regionId = this.user.shop.regionId;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },

    goBack() {
      this.$router.push("/price-models");
    },

    getActiveBrandList() {
      brandService
        .getBrandsByStatus("ACTIVE")
        .then((res) => {
          this.activeBrandList = res.data;
          this.activeBrandList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(this.findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveCategoryList() {
      categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.activeCategoryList = res.data;
          this.activeCategoryList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(this.findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getRegionList() {
      regionService
        .getRegionsByStatus("ACTIVE")
        .then((res) => {
          this.regionList = res.data;
          let noregion = {
            id: "",
            name: "----No Region----",
          };
          this.regionList.splice(0, 0, JSON.parse(JSON.stringify(noregion)));
        })
        .catch((err) => {
          console.log(err);
        });
    },

    showProducts() {
      // Clean query params
      this.queryParams.productCode = "";
      this.queryParams.productName = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },

    setProduct(code) {
      let product = commonService.search("code", code, this.productList);
      this.priceModelDetail = new PriceModelDetail();
      this.priceModelDetail.priceModelId = this.priceModel.id;
      this.priceModelDetail.productId = product.id;
      this.priceModelDetail.productCode = product.code;
      this.priceModelDetail.productName = product.name;
      this.priceModelDetail.productUnits = product.productUnits;
      this.priceModelDetail.factorUnitName = "";
      this.detailResponseError = "";
      let productUnit = commonService.search(
        "basicPriceflag",
        true,
        this.priceModelDetail.productUnits
      );
      if (productUnit) {
        this.priceModelDetail.factorUnitName = productUnit.factorUnitName;
        this.priceModelDetail.basicPriceflag = productUnit.basicPriceflag;
        this.priceModelDetail.productUnitId = productUnit.id;
        this.priceModelDetail.unitCost = productUnit.unitCost;
        this.priceModelDetail.unitPrice = productUnit.sellingPrice;
      }
      this.showDetailListDialog = !this.showDetailListDialog;
    },
    changeProductUnit(factorUnitName) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.priceModelDetail.productUnits
      );
      this.priceModelDetail.basicPriceflag = productUnit.basicPriceflag;
      this.priceModelDetail.productUnitId = productUnit.id;
      this.priceModelDetail.unitCost = productUnit.unitCost;
      this.priceModelDetail.unitPrice = productUnit.sellingPrice;
    },

    removePriceModelDetail(priceModelDetail) {
      this.deletePriceModelDetail = new PriceModelDetail();
      this.deletePriceModelDetail = priceModelDetail;
      this.deletePriceModelDetail.priceModelId = this.priceModel.id;
      this.confirmBox = true;
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.priceModel.id) {
        this.priceModel = new PriceModel();
        this.statusFlag = true;
      } else {
        this.priceModel = Object.assign({}, this.oldPriceModel);
        this.statusFlag = this.priceModel.status == "ACTIVE" ? true : false;
      }
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.priceModel.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        priceModelService
          .savePriceModel(this.priceModel)
          .then((res) => {
            if (res) {
              this.goBack();
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    getPriceModelDetail(id) {
      priceModelService
        .getPriceModelDetail(id)
        .then((res) => {
          this.priceModel = res.data;
          if (!this.priceModel.regionId) this.priceModel.regionId = "";
          else this.queryParams.regionId = this.priceModel.regionId;
          this.createdDate = commonService.formatDate(
            new Date(this.priceModel.createdDateInMilliSeconds)
              .toISOString()
              .substring(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.priceModel.updatedDateInMilliSeconds)
              .toISOString()
              .substring(0, 10),
            "YYYY-MM-DD"
          );
          // deep copy
          this.oldPriceModel = JSON.parse(JSON.stringify(this.priceModel));
          this.statusFlag = this.priceModel.status == "ACTIVE" ? true : false;
          this.getdetailProduct(this.priceModel.id);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    detailSearch() {
      this.priceModelDetailQueryParams.page = this.detailPagination.page;
      this.priceModelDetailQueryParams.size = this.detailPagination.rowsPerPage;
      this.getdetailProduct(this.priceModel.id);
    },
    getdetailProduct(id) {
      this.detailListLoading = true;
      let order = this.detailPagination.descending ? "desc" : "asc";
      this.priceModelDetailQueryParams.priceModelId = id;
      priceModelService
        .getPriceModelDetailProduct(
          this.priceModelDetailQueryParams,
          this.detailPagination.page,
          this.detailPagination.rowsPerPage,
          this.detailPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.priceModelDetailList = res.data.priceModelDetailList;
            this.detailTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.detailListLoading = false;
        });
    },
    cancel() {
      this.showDetailListDialog = !this.showDetailListDialog;
      if (!this.priceModelDetail.id) {
        this.showProductListDialog = !this.showProductListDialog;
      }
      this.getdetailProduct(this.priceModel.id);
    },
    saveDetail() {
      this.saveDetailLoading = true;
      priceModelService
        .savePriceModelDetail(this.priceModelDetail)
        .then((res) => {
          if (res) {
            this.showDetailListDialog = !this.showDetailListDialog;
            if (!this.priceModelDetail.id) {
              this.showProductListDialog = !this.showProductListDialog;
            }
            this.getdetailProduct(this.priceModel.id);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.detailResponseError = err.response.data.message;
          }
          this.saveDetailLoading = false;
        })
        .finally(() => {
          this.saveDetailLoading = false;
        });
    },
    deleteDetail() {
      priceModelService
        .deletePriceModelDetail(this.deletePriceModelDetail)
        .then((res) => {
          if (res) {
            this.confirmBox = false;
            this.getdetailProduct(this.priceModel.id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onEdit(priceModelDetail) {
      this.detailResponseError = "";
      this.priceModelDetail = new PriceModelDetail();
      this.priceModelDetail = priceModelDetail;
      this.priceModelDetail.priceModelId = this.priceModel.id;
      this.showDetailListDialog = !this.showDetailListDialog;
    },
    exportPriceModel() {
      this.buttonLoading = true;
      priceModelService
        .getPriceModelDetailExcelExport(this.priceModelDetailQueryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>